import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/ExpertAssessment`
//#region ExpertAssessment
//专家评审记录
const GetList = `${apiUrl}`
const GetCounts = `${apiUrl}/EntrustCount`
const GetResults = `${apiUrl}/GetResults`
const GetExperts = `${apiUrl}/GetExperts`
const PostAllocate = `${apiUrl}/AllocateExpert`
//委托专家信息
const GetAssessmentInfo = `${apiUrl}/GetAssessmentInfo`
const GetEntrustList = `${apiUrl}/GetEntrustList`
const PostAssessment = `${apiUrl}/ExpertAssessment`
const CloseAssessment = (id: number) => `${apiUrl}/CloseAssessment/${id}`
//#endregion
//委托专家实体
export const emptyAllocate: EightAllocateExpertData = {
    UnitList: [],
    ExpertList: [],
    Comments: ''
}
export const emptyAssessment: EightExpertAssessmentData = {
    Id: 0,
    UnitId: 0,
    ExpertId: 0,
    Status: 0,
    Comments: '',
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    UnitCode: '',
    UnitName: '',
    ExpertName: '',
    NewUserName: '',

    AssessmentId: 0,
    AssessmentStatus: 0,
    AssessmentResult: 0,
    AssessmentComments: '',
    AssessmentDate: new Date()
}
export interface EightAllocateExpertData {
    [key: string]: any
    UnitList: number[]
    ExpertList: number[]
    Comments: string
}
export interface EightExpertAssessmentData {
    [key: string]: any
    Id: number
    UnitId: number
    ExpertId: number
    Status: number
    Comments: string
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    UnitCode: string
    UnitName: string
    ExpertName: string
    NewUserName: string

    AssessmentId: number
    AssessmentStatus: number
    AssessmentResult: number
    AssessmentComments: string
    AssessmentDate: Date
}
export const getList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getCounts = () => {
    return tryAxios({
        method: 'get',
        url: GetCounts
    })
}
export const getResultList = () => {
    return tryAxios({
        method: 'get',
        url: GetResults
    })
}
export const getExpertList = (sKeyword: string, profession: number) => {
    return tryAxios({
        method: 'get',
        url: GetExperts,
        params: {
            keyword: sKeyword,
            professionId: profession
        }
    })
}
//委托专家
export const postAllocate = (form: EightAllocateExpertData) => {
    return tryAxios({
        method: 'post',
        url: PostAllocate,
        data: form
    })
}
export const getAssessmentInfo = (allocateId: number) => {
    return tryAxios({
        method: 'get',
        url: GetAssessmentInfo,
        params: {
            id: allocateId
        }
    })
}
export const getEntrustList = (allocateId: number) => {
    return tryAxios({
        method: 'get',
        url: GetEntrustList,
        params: {
            id: allocateId
        }
    })
}
//专家评审
export const postAssessment = (form: EightExpertAssessmentData) => {
    return tryAxios({
        method: 'post',
        url: PostAssessment,
        data: form
    })
}

//专家评审
export const closeAssessment = (id: number) => {
    return tryAxios({
        method: 'post',
        url: CloseAssessment(id),
    })
}